import styled from 'styled-components';

import { Marquee } from 'atoms/container/Marquee';
import { Img } from 'atoms/ui/Img';

const Root = styled.div`
  min-height: 80px;
`;

const Image = styled(Img)`
  scroll-snap-align: center;
  min-width: 80px;
`;

export type League = {
  displayName: string;
  pictureSecondaryUrl: string | null;
};

type Props = {
  leagues: League[];
};
export const Leagues = ({ leagues }: Props) => {
  return (
    <Root>
      {!!leagues.length && (
        <Marquee gap={4}>
          {leagues.map(
            ({ displayName, pictureSecondaryUrl }) =>
              pictureSecondaryUrl && (
                <Image
                  key={pictureSecondaryUrl}
                  src={pictureSecondaryUrl}
                  alt={displayName}
                  width="80"
                  height="80"
                  title={displayName}
                />
              )
          )}
        </Marquee>
      )}
    </Root>
  );
};
